import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import { ArrowLeft, Eye, FileEarmarkExcel, FileEarmarkSpreadsheet, Funnel, Printer, ThreeDotsVertical } from 'react-bootstrap-icons';
import { Badge, Button, Col, Dropdown, Form, FormControl, InputGroup, Modal, Row, Spinner, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import OutletSelect from '../../components/OutletSelect';

const SubscriptionConsumptionReport = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const animatedComponents = makeAnimated();
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    const accessToken = localStorage.getItem("authToken");
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState('');
    const [outlets, setOutlets] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedOutletName, setSelectedOutletName] = useState('');
    const [selectedSubscription, setSelectedSubscription] = useState('');
    const [subscriptionList, setSubscriptionList] = useState([]);
    const [btnLoading, setBtnLoading] = useState(false);
    const [printBtnLoading, setPrintBtnLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [clicked, setClicked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [singleData, setSingleData] = useState({});
    

    const getOutlets = async () => {
        try {
          const headers = { Authorization: `Bearer ${accessToken}` };
          const response = await axios.get("outlet", { headers });
    
          if (response?.data?.status === true) {
            const filteredOutlets = response?.data?.data?.outlets.filter((act) => act?.status === "ACTIVE");
            setOutlets(filteredOutlets);
          }
        } catch (error) {
          handleApiError(error);
        }
    };

    // Fetch subscriptions
    const getSubscriptions = async() => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("subscription", { headers });
            setSubscriptionList(response?.data?.data?.subscriptions);
            console.log("Subscription List :", response?.data?.data?.subscriptions);
            
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to fetch subscriptions", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    const getConsumptionReport = async(outlet) => {
        console.log("Selected Outlet :", outlet);
        
        try {
            const headers = { 
                Authorization: `Bearer ${accessToken}` 
            };
            let url = `subscription-purchase/outletsubscription`;
            if (outlet) {
                url += `?outletId=${outlet?.value}`
            }
            const response = await axios.get(url, { headers });
            setSubscriptionList(response?.data?.data?.list);
            setFilteredData(response?.data?.data?.list);
            console.log("Subscription List sdsdsdsd:", response?.data?.data);
            
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to fetch subscriptions", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setLoading(false);
        }
    }

    const handleApiError = (error) => {
        let errorMessage = 'An error occurred';
        if (error.response?.status === 406) {
            errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
        } else if (error.response?.status === 412) {
            errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
            errorMessage = error.response?.data?.error;
        }
    
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
    };

    const handleEndDateChange = (e) => {

    };

    const handlePrintReport = () => {
        console.log("You Are In Print Function");
        
    };

    const handleDownloadReport = async () => {
        setPrintBtnLoading(true);
        try {
            const headers = { 
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            };
            
            let url = `subscription-purchase/outletsubscription?isDownload=true`;
            if (selectedOutlet) {
                url += `&outletId=${selectedOutlet}`;
            }
            
            const response = await axios.get(url, { 
                headers,
                responseType: 'blob' // This is correct in the config object
            });

            // Create a blob from the response data
            const blob = new Blob([response.data], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            
            // Create a link element
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            
            // Set the filename for the download
            const fileName = `Subscritpion Consumption Report For - ${selectedOutletName}.xlsx`;
            link.download = fileName;
            
            // Append the link to the body and trigger the download
            document.body.appendChild(link);
            link.click();
            
            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);

            toast.success("Report downloaded successfully!", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } catch (error) {
            handleApiError(error);
        } finally {
            setPrintBtnLoading(false);
        }
    };

    const handleSubmitReport = async() => {
        setClicked(true);
        setLoading(true);
        await getConsumptionReport(selectedOutlet);
    };

    const handleViewDetails = (data) => {
        setOpenViewModal(true);
        console.log("Single Data :", data);
        
        setSingleData(data);
    }

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));
        
        setStartDate(start);
        setEndDate(end);
        getOutlets();
        getSubscriptions();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div
                className={`main main-app p-3 p-lg-4 ${
                skin === "dark" ? "bg-dark text-light" : "bg-light"
                }`}
            >
                <div className="card shadow-sm border-0">
                    <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="mb-0 fw-bold d-inline-block">
                                <i className="bi bi-clipboard-data me-2"></i>SUBSCRIPTION CONSUMPTION REPORT
                            </h4>
                        </div>
                        <div>
                            <Button 
                                variant="outline-secondary" 
                                size="sm" 
                                onClick={() => navigate('/reports/all-reports')}
                                className="me-3 d-flex align-items-center fw-semibold"
                                style={{ height: '38px' }}
                            >
                                <ArrowLeft className="me-1" /> Back to Reports
                            </Button>
                        </div>
                    </div>
                    <hr className='mt-0 mb-0' />
               
                    <div className="card-body">
                        {/* Filters Section */}
                        <div className="p-3 bg-light rounded-3">
                            {/* <Form onSubmit={handleSubmitReport}> */}
                                <Row className="g-3">
                                    <Col md={3}>
                                        <Form.Group controlId="outletSelect">
                                            <OutletSelect
                                                value={selectedOutlet}
                                                onChange={(option) => {
                                                    console.log("Selected Outlet :", option);
                                                    setSelectedOutlet(option);
                                                    setSelectedOutletName(option ? option.label : '');
                                                }}
                                                required={true}
                                            />
                                            {/* <Form.Select
                                                value={selectedOutlet}
                                                onChange={(e) => {
                                                        setSelectedOutletName(e.target.selectedOptions[0].label)
                                                        setSelectedOutlet(e.target.value)
                                                    }
                                                }
                                                className="border-secondary"
                                            >
                                                <option value="">Select Outlet</option>
                                                {outlets?.map((outlet) => (
                                                <option key={outlet?._id} value={outlet?._id} label={`${outlet?.name}, ${outlet?.city}`}>
                                                    {outlet?.name}
                                                </option>
                                                ))}
                                            </Form.Select> */}
                                        </Form.Group>
                                    </Col>
                                    <Col md={2} className="d-flex align-items-end">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100"
                                            disabled={!selectedOutlet}
                                            onClick={handleSubmitReport}
                                        >
                                            {btnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Generate Report"
                                            )}
                                        </Button>
                                    </Col>
                                    <Col md={2} lg={2} className="d-flex align-items-end">
                                        <Button
                                            variant="outline-success"
                                            className="w-100 fw-semibold"
                                            disabled={!selectedOutlet}
                                            onClick={handleDownloadReport}
                                        >
                                            <FileEarmarkSpreadsheet className='me-2' />
                                            {printBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Download Report"
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            {/* </Form> */}
                        </div>
                
                    </div>

                    {!clicked ? (
                            <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                                <div className="text-center">
                                    <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                    <h5 className="text-muted mt-3">
                                    Please select outlet to view report
                                    </h5>
                                </div>
                            </div>
                        ) : (
                            <>
            
                                {/* Items Table */}
                                <div className="table-responsive border rounded-3 m-3">
                                    <Table striped bordered hover className="mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Date</th>
                                                <th>Outlet Name</th>
                                                <th>Subscription Plan</th>
                                                <th className="text-center">Order Count</th>
                                                <th>Subscription Amount Used</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                            <tr>
                                                <td colSpan="12" className="text-center py-4">
                                                    <Spinner animation="border" variant="primary" />
                                                    <p className="mt-2 mb-0">Loading item data...</p>
                                                </td>
                                            </tr>
                                            ) : filteredData?.length > 0 ? (
                                            <>
                                                {filteredData?.map((product, index) => (
                                                    <tr key={index}>
                                                        <td className="text-muted">{index + 1}</td>
                                                        <td>{new Date(product?.subscriptionDetails?.createdAt).toLocaleString('en-IN', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                            })}
                                                        </td>

                                                        <td>{product?.outletDetails?.name}</td>
                                                        <td>
                                                            <div className="text-primary">{product?.subscriptionDetails?.title}</div>
                                                        </td>
                                                        <td className="text-center">{product?.totalOrders}</td>
                                                        <td className="text-end">₹ {product?.totalSubscriptionConsumedAmount?.toFixed(2)}</td>
                                                        <td>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" id="dropdown-basic" size="sm">
                                                                    <ThreeDotsVertical size={15} />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item onClick={() => handleViewDetails(product)}>
                                                                        <Eye size={14} className="me-2" /> View
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                ))}
                                                
                                            </>
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4">
                                                        <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                                                        <p className="mt-2 mb-0 text-muted">
                                                            No items found for the selected criteria
                                                        </p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
            
                            </>
                        )
                    }

                    {/* View Details Modal  */}
                    {openViewModal && (
                        <Modal 
                            show={openViewModal}
                            onHide={() => setOpenViewModal(false)}
                            size="xl"
                            centered
                            className="outlet-details-modal"
                        >
                            <Modal.Header closeButton className="border-bottom-0 pb-0">
                                <Modal.Title className="fw-bold">More Details</Modal.Title>
                            </Modal.Header>
                            
                            <Modal.Body className="p-0">
                            {singleData && (
                                <div className="container-fluid">
                                <div className="row g-0">
                                    {/* Left Column - Outlet Details */}
                                    <div className="col-md-5 p-4 border-end" style={{ backgroundColor: '#f8f9fa' }}>
                                    <div className="sticky-top" style={{ top: '1rem' }}>
                                        
                                        {/* Outlet Information Card */}
                                        <div className="mb-4">
                                        <h5 className="fw-bold mb-3">Outlet Information</h5>
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h6 className="mb-0">Status</h6>
                                                <Badge 
                                                bg={singleData?.outletDetails?.status === 'ACTIVE' ? 'success' : 'danger'} 
                                                pill
                                                >
                                                {singleData?.outletDetails?.status}
                                                </Badge>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Outlet</h6>
                                                <p className="mb-0">{singleData?.outletDetails?.name}</p>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Opening Time</h6>
                                                <p className="mb-0">{singleData?.outletDetails?.openingTime}</p>
                                            </div>

                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Closing Time</h6>
                                                <p className="mb-0">{singleData?.outletDetails?.closingTime}</p>
                                            </div>
                                            
                                            {singleData?.outletDetails?.outletImage && (
                                                <div className="mt-3">
                                                <h6 className="text-muted small mb-2">Outlet Image</h6>
                                                <img
                                                    src={`${singleData.outletDetails.outletImage}`}
                                                    className="img-fluid rounded border"
                                                    alt="Outlet"
                                                />
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                        
                                        {/* Subscription Details Card */}
                                        <div className="mb-4">
                                        <h5 className="fw-bold mb-3">Subscription Details</h5>
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Subscription Plan</h6>
                                                <p className="mb-0">{singleData?.subscriptionDetails?.title}</p>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Days Excluded</h6>
                                                <p className="mb-0">
                                                {singleData?.subscriptionDetails?.excludedDays?.join(', ') || 'N/A'}
                                                </p>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Price</h6>
                                                <p className="mb-0">
                                                ₹ {singleData?.subscriptionDetails?.price}
                                                </p>
                                            </div>
                                            
                                            {singleData?.subscriptionDetails?.otherImage && (
                                                <div className="mt-3">
                                                <h6 className="text-muted small mb-2">Subscription Proof</h6>
                                                <img
                                                    src={`${singleData?.subscriptionDetails?.otherImage}`}
                                                    className="img-fluid rounded border"
                                                    alt="Subscription Proof"
                                                />
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                        
                                        {/* Order Statistics Card */}
                                        <div className="card border-0 shadow-sm">
                                        <div className="card-body">
                                            <h5 className="fw-bold mb-3">Order Statistics</h5>
                                            
                                            <div className="d-flex justify-content-between mb-2">
                                            <span className="text-muted">Total Orders:</span>
                                            <span className="fw-bold">{singleData?.totalOrders}</span>
                                            </div>
                                            
                                            <div className="d-flex justify-content-between">
                                            <span className="text-muted">Total Amount:</span>
                                            <span className="fw-bold">₹ {singleData?.totalSubscriptionConsumedAmount?.toFixed(2)}</span>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                    
                                    {/* Right Column - User Orders */}
                                    <div className="col-md-7 p-4">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <h5 className="fw-bold mb-0">User Orders</h5>
                                        <Badge bg="secondary" pill>
                                        {singleData?.usersWithOrders?.length || 0} users
                                        </Badge>
                                    </div>
                                    
                                    {singleData?.usersWithOrders?.length > 0 ? (
                                        <div style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                                            {singleData.usersWithOrders.map((user, index) => (
                                                <div key={user?.userId} className="card border-0 shadow-sm mb-3">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                                        <div>
                                                            <h6 className="fw-bold mb-1">{user?.userName}</h6>
                                                            <p className="text-muted small mb-1">{user?.userEmail}</p>
                                                            <p className="text-muted small mb-0">{user?.userMobile}</p>
                                                            <span className="text-muted small">Puchased on : {user?.purchase?.startDate}</span>
                                                                <br />
                                                            <span className="text-muted small">Expires or Expired on : {user?.purchase?.expiryDate}</span>
                                                        </div>
                                                        <div className="text-end">
                                                            <div className="fw-bold">
                                                                ₹{user?.totalUserConsumedAmount?.toFixed(2)}
                                                            </div>
                                                            <Badge bg="light" text="dark" className="text-capitalize">
                                                                {user?.orders?.length || 0} orders
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                    
                                                    {user?.orders?.length > 0 && (
                                                        <div className="border-top pt-3">
                                                            <h6 className="text-muted small mb-2">ORDERS</h6>
                                                            {user.orders.map((order, orderIndex) => (
                                                                <div key={order._id} className="mb-3 pb-2 border-bottom">
                                                                    <div className="d-flex justify-content-between mb-1">
                                                                    <span className="fw-medium">Order #A{order.order_no}</span>
                                                                    <span className="fw-bold">₹{order.grandTotal?.toFixed(2)}</span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between text-muted small">
                                                                        <span>
                                                                            {new Date(order.createdAt).toLocaleString('en-US', {
                                                                                year: 'numeric',
                                                                                month: 'short',
                                                                                day: 'numeric',
                                                                                hour: '2-digit',
                                                                                minute: '2-digit',
                                                                                hour12: true
                                                                            })}
                                                                        </span>
                                                                        <span>
                                                                            {order.orderItem ? '1 item' : 'No items'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <div className="bg-light rounded-circle d-inline-flex p-4 mb-3">
                                                <Funnel size={28} className="text-muted" />
                                            </div>
                                            <h5 className="mb-2">No orders found</h5>
                                            <p className="text-muted">
                                                This outlet doesn't have any orders yet.
                                            </p>
                                        </div>
                                    )}
                                    </div>
                                </div>
                                </div>
                            )}
                            </Modal.Body>
                            
                            <Modal.Footer className="border-top-0">
                                <Button variant="outline-secondary" onClick={() => setOpenViewModal(false)}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                </div>
            </div>
        </React.Fragment>
    )
}

export default SubscriptionConsumptionReport